import { EventSearchFormType as _EventSearchFormType } from '@mark43/cad-api';

export enum FileExportType {
    PDF = 'PDF',
    CSV = 'CSV',
}

export type EventSearchFormType = Omit<_EventSearchFormType, 'polygonPoints'> & {
    polygonPoints: { latitude: string | null; longitude: string | null }[];
};

export type FileExportHandlerType = (args: { type?: FileExportType; entityIds?: number[] }) => void;
